import React from 'react';
import { BackButtonContainer } from './style';
import { history } from '../../../app/redux/store';
import { Container } from '../../gridSystem';
import CTA from '../CTA';

const BackButton = (props) => {
  const handleClick = () => {
    history.goBack();
  };

  return (
    <BackButtonContainer>
      <Container className="pt-0">
        <CTA
          btnText="Torna indietro"
          onClick={handleClick}
          type="tertiary"
          icon="arrow-narrow-left"
          iconPosition="start"
        />
      </Container>
    </BackButtonContainer>
  );
};

export default BackButton;
